// extracted by mini-css-extract-plugin
export default {"buttonStyles":"Button_buttonStyles__iAVx0","disabledButtonCursor":"Button_disabledButtonCursor__gzrxu","opacityOnDisable":"Button_opacityOnDisable__RbeS4"};